module.exports = __webpack_public_path__ + "img/stock.cb097432.png";